import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'div[data-component-type=icon-tick]',
  templateUrl: './tick.component.html',
  styleUrls: ['./tick.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TickComponent implements OnInit {

  @Input() type: TickIconType = 'normal'

  constructor() { }

  ngOnInit(): void {
  }

}

export type TickIconType = 'normal' | 'success'
